<template>
<b-card :title="$t('message.Guideline.section2')" class="mb-2" v-if="active">
  <b-row class="my-1" v-if="guideline.id != null">
    <b-col sm="3">
      <label class="col-form-label">{{ $t('message.Guideline.submitter') }} <var class="text-danger">*</var></label>
    </b-col>
    <b-col sm="9">
      <label class="col-form-label text-left">
        {{ guideline.submitter_name }}
      </label>
    </b-col>
  </b-row>

  <b-row class="my-1">
    <b-col sm="3">
      <label class="col-form-label">{{ $t('message.Guideline.coAuthor') }} <var class="text-danger">*</var></label>
    </b-col>
    <b-col sm="9">
      <v-select
        v-model="guideline.co_author"
        :options="coAuthorOptions"
        v-validate="{ required: true }"
        class="mb-2"
        data-vv-scope="step.1"
        data-vv-name="guideline.co_author"
        >
      </v-select>
      <div v-if="errors.first('guideline.co_author')" class="text-danger">{{ $t('message.fieldRequiredInfo') }}</div>
    </b-col>
  </b-row>

  <b-row class="my-1">
    <b-col sm="3">
      <label class="col-form-label">{{ $t('message.Guideline.coCoAuthor') }} <var class="text-danger">*</var></label>
    </b-col>
    <b-col sm="9">
      <b-row>
        <b-col sm="3">
          <b-form-input 
            type="text"
            :placeholder="$t('message.User.firstName')"
            v-model="guideline.co_co_author.first_name"
            v-validate="'required'"
            data-vv-scope="step.1"
            :data-vv-name="'guideline.co_co_author.first_name'"
            :state="errors.first('guideline.co_co_author.first_name')?'invalid':'true'"
          ></b-form-input>
        </b-col>
        <b-col sm="3">
          <b-form-input 
            type="text"
            :placeholder="$t('message.User.lastName')"
            v-model="guideline.co_co_author.last_name"
            v-validate="'required'"
            data-vv-scope="step.1"
            :data-vv-name="'guideline.co_co_author.last_name'"
            :state="errors.first('guideline.co_co_author.last_name')?'invalid':'true'"
          ></b-form-input>
        </b-col>
        <b-col sm="4">
          <b-form-input
            type="text"
            placeholder="email"
            v-model="guideline.co_co_author.email"
            v-validate="'required|email'"
            data-vv-scope="step.1"
            :data-vv-name="'guideline.co_co_author.email'"
            :state="errors.first('guideline.co_co_author.email')?'invalid':'true'"
            ></b-form-input>
        </b-col>
      </b-row>
    </b-col>
  </b-row>

  <b-row class="my-1">
    <b-col sm="3">
      <label class="col-form-label">{{$t('message.Guideline.coAuthors')}}</label>
    </b-col>
    <b-col sm="9">
      <b-row v-for="(user, idx) in guideline.co_authors" class="my-1" :key="idx">
        <b-col sm="3">
          <b-form-input 
            type="text"
            :placeholder="$t('message.User.firstName')"
            v-model="guideline.co_authors[idx].first_name"
            v-validate="'required'"
            data-vv-scope="step.1"
            :data-vv-name="'guideline.co_authors[' + idx + '].first_name'"
            :state="errors.first('guideline.co_authors[' + idx + '].first_name')?'invalid':'true'"
          ></b-form-input>
        </b-col>
        <b-col sm="3">
          <b-form-input 
            type="text"
            :placeholder="$t('message.User.lastName')"
            v-model="guideline.co_authors[idx].last_name"
            v-validate="'required'"
            data-vv-scope="step.1"
            :data-vv-name="'guideline.co_authors[' + idx + '].last_name'"
            :state="errors.first('guideline.co_authors[' + idx + '].last_name')?'invalid':'true'"
          ></b-form-input>
        </b-col>
        <b-col sm="4">
          <b-form-input
            type="text"
            placeholder="email"
            v-model="guideline.co_authors[idx].email"
            v-validate="'required|email'"
            data-vv-scope="step.1"
            :data-vv-name="'guideline.co_authors[' + idx + '].email'"
            :state="errors.first('guideline.co_authors[' + idx + '].email')?'invalid':'true'"
            ></b-form-input>
        </b-col>
        <b-col sm="2">
          <b-button @click="addCoAuthor">+</b-button>
          <b-button variant="danger" @click="rmCoAuthor(idx)">-</b-button>
        </b-col>
      </b-row>

      <template v-if="guideline.co_authors==0">
        <b-button @click="addCoAuthor">+</b-button>
      </template>
    </b-col>
  </b-row>

  <b-row class="my-1">
    <b-col sm="3">
      <label class="col-form-label">{{$t('message.Guideline.exCoAuthors')}}</label>
    </b-col>
    <b-col sm="9">
      <b-row v-for="(user, idx) in guideline.ex_co_authors" class="my-1" :key="idx">
        <b-col sm="3">
          <b-form-input 
            type="text"
            :placeholder="$t('message.User.firstName')"
            v-model="guideline.ex_co_authors[idx].first_name"
            v-validate="'required'"
            data-vv-scope="step.1"
            :data-vv-name="'guideline.ex_co_authors[' + idx + '].first_name'"
            :state="errors.first('guideline.ex_co_authors[' + idx + '].first_name')?'invalid':'true'"
          ></b-form-input>
        </b-col>
        <b-col sm="3">
          <b-form-input 
            type="text"
            :placeholder="$t('message.User.lastName')"
            v-model="guideline.ex_co_authors[idx].last_name"
            v-validate="'required'"
            data-vv-scope="step.1"
            :data-vv-name="'guideline.ex_co_authors[' + idx + '].last_name'"
            :state="errors.first('guideline.ex_co_authors[' + idx + '].last_name')?'invalid':'true'"
          ></b-form-input>
        </b-col>
        <b-col sm="4">
          <b-form-input
            type="text"
            placeholder="society"
            v-model="guideline.ex_co_authors[idx].society"
            v-validate="'required'"
            data-vv-scope="step.1"
            :data-vv-name="'guideline.ex_co_authors[' + idx + '].society'"
            :state="errors.first('guideline.ex_co_authors[' + idx + '].society')?'invalid':'true'"
            ></b-form-input>
        </b-col>
        <b-col sm="2">
          <b-button @click="addExCoAuthor">+</b-button>
          <b-button variant="danger" @click="rmExCoAuthor(idx)">-</b-button>
        </b-col>
      </b-row>

      <template v-if="guideline.ex_co_authors==0">
        <b-button @click="addExCoAuthor">+</b-button>
      </template>
    </b-col>
  </b-row>

  <b-row class="my-1">
    <b-col sm="3">
      <label class="col-form-label">{{$t('message.Guideline.reviewUsers')}}</label>
    </b-col>
    <b-col sm="9">
      <v-select
        v-model="guideline.review_user_ids"
        :options="rewievers"
        class="mb-2"
        multiple
        >
      </v-select>
    </b-col>
  </b-row>
  
  <template v-if="externalUse">
    <b-button variant="success" @click="applyChanges" class="float-right">{{$t('message.apply')}}</b-button>
    <b-button variant="link" @click="$emit('hideInvolvedParties')" class="float-right">{{$t('message.cancel')}}</b-button>
  </template>
</b-card>
</template>


<script>
import { USERS_REQUEST_COMMITTEE_AND_EXTERNAL_USERS } from '@/store/actions/users';
import { GUIDELINE_SILENCE_UPDATE } from '@/store/actions/guidelines';

export default {
  name: 'involved-parties',
  inject: {
    $validator: '$validator'
  },
  components: {},
  props: ['guideline', 'active', 'external'],
  data () {
    return {
      users: [],
      externalUse: false,
    }
  },
  computed: {
    /**
     * users options when edit in view mode
     */
    coAuthorOptions: {
      get: function () {
        this.initializeCoCoAuthor();
        let forbidden = new Array;

        /**
         * co co author_id
         */
        if (this.guideline.co_co_author && this.guideline.co_co_author.value) {
          forbidden.push(this.guideline.co_co_author.value);
        }

        /**
         * Rewievers
         */
        if (this.guideline.review_user_ids) {
          let rid = this.guideline.review_user_ids.map(elem => {return elem.value});
          forbidden = forbidden.concat(rid)
        }

        if (forbidden.length > 0) {
          let options = this.users.filter(elem => {
            return forbidden.indexOf(elem.value) == -1;
          });

          return options;
        }

        return this.users;
      }
    },

    coCoAuthorOptions: {
      get: function () {
        let forbidden = new Array;

        /**
         * co author_id
         */
        if (this.guideline.co_author && this.guideline.co_author.value) {
          forbidden.push(this.guideline.co_author.value);
        }

        /**
         * Rewievers
         */
        if (this.guideline.review_user_ids) {
          let rid = this.guideline.review_user_ids.map(elem => {return elem.value});
          forbidden = forbidden.concat(rid)
        }

        if (forbidden.length > 0) {
          let options = this.users.filter(elem => {
            return forbidden.indexOf(elem.value) == -1;
          });

          return options;
        }

        return this.users;
      }
    },

    rewievers: {
      get: function () {
        let forbidden = new Array;

        let commiteeUsers = this.users.filter(elem => {
          return elem.role == 2;
        });

        /**
         * co author_id
         */
        if (this.guideline.co_author && this.guideline.co_author.value) {
          forbidden.push(this.guideline.co_author.value);
        }

        /**
         * co co author_id
         */
        if (this.guideline.co_co_author && this.guideline.co_co_author.value) {
          forbidden.push(this.guideline.co_co_author.value);
        }

        if (forbidden.length > 0) {
          let options = commiteeUsers.filter(elem => {
            return forbidden.indexOf(elem.value) == -1;
          });

          return options.map(elem => { return {value: elem.value, label: elem.label + ' [' + elem.committee + ']' }});
        }

        return commiteeUsers.map(elem => { return {value: elem.value, label: elem.label + ' [' + elem.committee + ']' }});
      }
    },


    /**
     * users options when edit in view mode -end
     */
  },
  mounted () {
    if (this.external) {
      this.externalUse = true;
    }
    this.getUsers();
  },
  methods: {
    getUsers() {
      let labelNotSet = this.$t('message.User.committeeNotSet')

      this.$store.dispatch(USERS_REQUEST_COMMITTEE_AND_EXTERNAL_USERS).then((response) => {
        this.users = [];

        for (let x in response.data.data) {
          let value = response.data.data[x].id;
          let label = response.data.data[x].name;
          let role = response.data.data[x].role;
          let committee = response.data.data[x].committee ? response.data.data[x].committee : labelNotSet;

          this.users.push( { value, label, role, committee } );
        }
      }).catch((error) => {
        this.handleUnauth(error.response.status);
      });
    },

    initializeCoCoAuthor() {
      if (!this.guideline.co_co_author || Object.keys(this.guideline.co_co_author).length === 0) {
        this.guideline.co_co_author = {
          first_name: '',
          last_name: '',
          email: '',
          label: ''
        };
      }
    },

    addCoAuthor() {
      this.guideline.co_authors.push({name:null, email:null})
    },

    rmCoAuthor(index) {
      this.guideline.co_authors.splice(index, 1);
    },

    addExCoAuthor() {
      this.guideline.ex_co_authors.push({name:null, society:null})
    },

    rmExCoAuthor(index) {
      this.guideline.ex_co_authors.splice(index, 1);
    },

    applyChanges() {
      this.$validator.validateAll('step.1').then(result => {
        if (result) {
          let title = this.$t("message.success");
          let message = this.$t("message.success");

          this.$store.dispatch(GUIDELINE_SILENCE_UPDATE, this.guideline).then(() => {
            this.$swal({
              title: title,
              text: message,
              type: 'success',
              confirmButtonText: 'OK'
            }).then(()=> {
              this.hideComponent()
            })
          }).catch((error) => {
            this.handleUnauth(error.response.status);
            this.handleForbidden(error.response.status);
          });
        }
      });
    },

    hideComponent() {
      this.$emit('hideInvolvedParties');
    }
  },
}
</script>

<style scoped lang="scss">
  
</style>

